import { Component, Inject } from '@angular/core';
import { AppState } from '../../../app.state';
import { Store } from '@ngrx/store';
import { DismissFlash } from '../store/flash.actions';
import { authenticatedPatientSelector } from '../../../../main/selectors/patients-selectors';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'flash-update-profile',
  template: require('./flash-update-profile.component.html'),
})
export class FlashUpdateProfileComponent {
  public startToken: string;
  public phoneNumber: string;
  public address: string;
  private destroyed: Subject<boolean> = new Subject();

  constructor(
    @Inject('$state') private $state,
    private store: Store<AppState>,
  ) {}

  ngOnInit() {
    this.store.select(authenticatedPatientSelector)
      .takeUntil(this.destroyed)
      .subscribe((currentPatient: any) => {
        if (!currentPatient) {
          this.dismiss();
        } else {
          const profile = currentPatient.profile;
          this.phoneNumber = profile.contactMethods[0] && profile.contactMethods[0].number;
          this.address = profile.street;

          this.startToken = `flash_update_profile.${this.address ? 'with' : 'no'}_address.${this.phoneNumber ? 'with' : 'no'}_phone`;
        }
    });
  }

  ngOnDestroy() {
    this.destroyed.next(true);
  }

  goToProfile() {
    this.$state.go('patients.id.update.personal-information', { '#': (this.address ? 'change-contact-infos-form' : 'change-address-form') });
    this.dismiss();
  }

  dismiss() {
    this.store.dispatch(new DismissFlash());
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/flash/flash-update-profile/flash-update-profile.component.ts